namespace e5 {
    export interface DocumentLoaderOptions extends AjaxLoaderOptions {

    }

    class DocumentLoader extends AbstractAjaxLoader<Document, DocumentLoaderOptions>{
        protected defaultOptions(): DocumentLoaderOptions {
            return {
                decoder: "document"
            }
        }
    }

    export interface LoaderOptionsMap {
        "document": DocumentLoaderOptions;
    }

    export interface LoaderMap {
        "document": DocumentLoader;
    }

    registerLoader("document", DocumentLoader);
}